﻿let $ = require('jquery');
let Tracker = require('./Tracker');

module.exports = ClicksTracking;

function ClicksTracking() {
    $('.jnf-widget-menu-1 .social-media a').on('click', function () {
        const network = this.dataset.network;
        Tracker.headerSocialMediaButtonClick({ network });
    });

    $('footer .social-media a').on('click', function () {
        const network = this.dataset.network;
        Tracker.footerSocialMediaButtonClick({ network });
    });

    $('.jnf-widget-menu-1-account.subscribe').on('click', function () {
        Tracker.subscribeButtonClick();
    });

    $('.footer-link1, .footer-link2, .footer-link3').on('click', function () {
        const link = $(this).attr('href');
        Tracker.charityWatchdogsClick({ link })
    });

    $('.jnf-widget-slideshow-details-list-item, .jnf-widget-slideshow-photo-container-list-item').on('click', function () {
        const link = $(this).parent('a').attr('href');
        const index = this.dataset.index;
        Tracker.carouselClick({
            imageIndex: index,
            targetURL: link,
            page: window.location.pathname
        });
    });

    // Below are hacks for tracking editable content
    $('.jnf-widget-featured-sponsors.donors').find('a').on('click', function () {
        Tracker.featuredDonorsClick({ page: window.location.pathname });
    });

    $('.jnf-widget-menu-2.simplified').find('a')
        .filter(function (index) { return $(this).text() === "Donate by mail"; })
        .on('click', () => Tracker.headerDonateByMailClick());

    $('.jnf-widget-menu-1-various-buttons').find('a')
        .filter(function (index) { return $(this).text() === "Donate"; })
        .on('click', () => Tracker.headerDonateClick({
            page: window.location.pathname
        }));

    $('.jnf-widget-full-donation .donate-by-mail').on('click', () => Tracker.formDonateByMailClick());

    $('.jnf-widget-menu-2.simplified a[href*="tel://"]').on('click', () => Tracker.headerPhoneClick());
    
    $('footer a[href*="tel:"]').on('click', function () {
        const phoneNumber = $(this).attr('href');
        Tracker.footerPhoneClick({ phoneNumber });
    });
}